import "core-js/stable";
import "regenerator-runtime/runtime";

import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "channels";

Rails.start();
ActiveStorage.start();

// Stimulus
import "controllers";

// Bootstrap
import "bootstrap";
import "../../stylesheets/help/application.scss";

// Images
const images = require.context("../../images/help", true); // eslint-disable-line no-unused-vars
